import {Injectable} from '@angular/core';
import {Observable, BehaviorSubject} from 'rxjs';
import {UserData} from '../interfaces/user-data';


@Injectable()
export class UserService {

  /**
   * Die Daten des eingeloggten Benutzers als Json-Objekt
   *
   * @var userData
   */
  private userData: UserData;

  /**
   * Das Subject-Array welches den anderen Klassen bereitgestellt werden kann
   */
  private loginState = new BehaviorSubject<boolean>(false);

  constructor() {
    this.retrieveUserData();
  }

  /**
   * Funktion zum Setzen des nächsten LoginState der als Observable bereitgestellt wird
   */
  private setLoginState(state: boolean) {
    this.loginState.next(state);
  }

  /**
   * Gibt ein Observable mit dem Loginstate zurück
   */
  public getLoginState(): Observable<any> {
    return this.loginState.asObservable();
  }

  /**
   * Holt die Benutzerdaten aus dem Localstorage
   *
   * @returns boolean
   */
  private retrieveUserData(): boolean {
    const userData = localStorage.getItem('userData');
    if (typeof userData !== 'string') {
      this.setLoginState(false);
      return false;
    }
    try {
      this.userData = <UserData>JSON.parse(userData);
      this.setLoginState(true);
      return true;
    } catch (e) {
      this.setLoginState(false);
      return false;
    }
  }

}
